import React, { useState, useEffect } from "react";

import { Link } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import {
  InteractionStatus
} from "@azure/msal-browser";
import {
  useMsal,
} from "@azure/msal-react";

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  const [authState, setAuthState] = useState(false);
  const { instance, accounts, inProgress } = useMsal();

  useEffect(() => {
    // More robust authentication check: verify accounts exist and MSAL is no longer in progress
    const isReady = isAuthenticated && accounts && accounts.length > 0 && inProgress === InteractionStatus.None;
    setAuthState(isReady);
  }, [isAuthenticated, accounts, inProgress]);

  if (authState) {
    return children;
  } else {
    return (
      <>
        <div className="unauthorized">
          {
            inProgress == InteractionStatus.Login ? <p>Logging in...</p> : inProgress == InteractionStatus.None && !accounts?.length ? <p>Please wait...</p> : <>
              <p>You are not authenticated. Please login to continue</p>
              <Link to='/login' className="link">Go To Login</Link></>
          }
        </div>
      </>
    );
  }
};

export default ProtectedRoute;
